/**
 * Builds the `window.open` features string that forces a separate browser
 * window (not a tab). The `popup` keyword plus explicit dimensions is what makes
 * browsers spawn a standalone window; it is sized to a portion of the available
 * screen and centred, falling back to sensible defaults when screen metrics are
 * unavailable (e.g. in tests).
 * @returns {string} The comma-separated window features.
 */
export function popupWindowFeatures(): string {
  const screen = globalThis.screen;
  const width = Math.round((screen?.availWidth ?? 1280) * 0.7);
  const height = Math.round((screen?.availHeight ?? 900) * 0.85);
  const left = Math.round(((screen?.availWidth ?? 1280) - width) / 2);
  const top = Math.round(((screen?.availHeight ?? 900) - height) / 2);
  return `popup,width=${width},height=${height},left=${left},top=${top}`;
}
